export enum Capabilities {
    INVENTORY_MANAGE = 'inventory_manage',
    INVENTORY_SHOW = 'inventory_show',
}
